/**
 * @generated SignedSource<<ef94b0874abc43f30852ba758343cc88>>
 * @relayHash ee8a3dac2dd27c3f22956b9a2186705e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID af31a7f9f3d822a2d8000b40dd13226210bed2df01d01e5d56d1a6233e486ce2

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraVersionUpdateMutationInput = {
  description?: string | null | undefined;
  driver?: string | null | undefined;
  id: string;
  name: string;
  releaseDate?: AGG$DateTime | null | undefined;
  startDate?: AGG$DateTime | null | undefined;
};
export type useUpdateVersionDateMutation_updateVersionDateMutation$variables = {
  input: JiraVersionUpdateMutationInput;
};
export type useUpdateVersionDateMutation_updateVersionDateMutation$data = {
  readonly jira: {
    readonly updateJiraVersion: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
      readonly version: {
        readonly id: string;
        readonly releaseDate: AGG$DateTime | null | undefined;
        readonly startDate: AGG$DateTime | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateVersionDateMutation_updateVersionDateMutation = {
  response: useUpdateVersionDateMutation_updateVersionDateMutation$data;
  variables: useUpdateVersionDateMutation_updateVersionDateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "concreteType": "JiraVersion",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "startDate"
    },
    {
      "kind": "ScalarField",
      "name": "releaseDate"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useUpdateVersionDateMutation_updateVersionDateMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionPayload",
            "kind": "LinkedField",
            "name": "updateJiraVersion",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateVersionDateMutation_updateVersionDateMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionPayload",
            "kind": "LinkedField",
            "name": "updateJiraVersion",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "af31a7f9f3d822a2d8000b40dd13226210bed2df01d01e5d56d1a6233e486ce2",
    "metadata": {},
    "name": "useUpdateVersionDateMutation_updateVersionDateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8fb2415802ee7059b896d42daa43d041";

export default node;
